import { z } from 'zod'

export const ADMINPERSONABASEPUT_CONTRACT_VERSION = '1.0.0' as const
export const adminPersonaBasePutResponseSchema = z.unknown()
export type AdminPersonaBasePutResponse = z.infer<typeof adminPersonaBasePutResponseSchema>
